import { ElementRef, Pipe, PipeTransform } from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import * as _ from "lodash";
import { ContractSearchService } from '../Services/contract-search.service';

@Pipe({
    name: 'searchContract',

})
export class SearchContractPipe implements PipeTransform {

    constructor(private sanitizer: DomSanitizer, private dataService: ContractSearchService) { }


    transform(value: any, args: any, sectionCount: any, MatchDetails: any, filterMetadata: any, index: any, initialLoad: boolean, elementRef: any): any {

        if (!args) {
            return value;
        }

        if (!args || /[<>{}]/.test(args)) {
            return value;
        }

        if (args != undefined && args.length < 3) {
            index.count = 0;
            this.dataService.setCurrentPosition(index.count);
            return value;
        }

        let parentElement = elementRef.parentElement;
        while (parentElement) {
            if (parentElement.hidden) {
                return value;
            }
            parentElement = parentElement.parentElement;
        }

        //value = value.replace(/<[^>]*>/g, '');
        // Match in a case insensitive maneer
        var match = '';
        const re = new RegExp(`(?![^<>]*>)${args}`, 'gi');
        if (value.changingThisBreaksApplicationSecurity != undefined) {
            match = value.changingThisBreaksApplicationSecurity.match(re);
        }
        else {
            match = value.match(re);
        }

        // If there's no match, just return the original value.
        if (!match) {
            if (!initialLoad) {
                return value;
            }
            else {
                this.dataService.setCurrentPosition(index.count);
                this.dataService.setTotalSearchCount(filterMetadata.count);
                return value;
            }
        }

        if (match.length > 0) {

            if (initialLoad) {
                //search the text when text entered in search bar
                var Section =
                {
                    Id: sectionCount.count,
                    Value: value,
                    TotalHighlight: _totalhighlight
                }
                var _totalhighlight = [];
                var highlightSect = { key: 0, highlight: 0 };

                var searchResult;
                index.count = 0;
                this.dataService.setCurrentPosition(index.count);
                for (var i = 0; i < match.length; i++) {

                    if (Section.Id > 0) {
                        var totalcount = filterMetadata.count;
                        let newHighlight = _.cloneDeep(highlightSect);
                        newHighlight.key = i;
                        newHighlight.highlight = totalcount + i;
                        _totalhighlight.push(newHighlight);
                    }
                    else {
                        let newHighlight = _.cloneDeep(highlightSect);
                        newHighlight.key = i;
                        newHighlight.highlight = i;
                        _totalhighlight.push(newHighlight);
                    }
                }

                filterMetadata.count > 0 ? searchResult = activeHighlight(value, re, null) : searchResult = activeHighlight(value, re, index.count);
                filterMetadata.count += match.length;
                this.dataService.setTotalSearchCount(filterMetadata.count);/// send total count of highlights to the service.
                if (filterMetadata.count != 0) {// send section expand value to the service.
                    this.dataService.setExpandValue(true);
                }

                Section.Id = sectionCount.count;
                Section.Value = value;
                Section.TotalHighlight = _totalhighlight;
                MatchDetails.push(Section);

                sectionCount.count = sectionCount.count + 1;
                index.count = index.count + 1;
                this.dataService.setCurrentPosition(index.count);
                //remove the object values
                _totalhighlight = [];

                return this.sanitizer.bypassSecurityTrustHtml(searchResult);
            }
            else {
                // change the activation based on next and previous button
                var activePosition;
                var formartValue;
                for (var sec = 0; sec < MatchDetails.length; sec++) {
                    for (var item = 0; item < MatchDetails[sec].TotalHighlight.length; item++) {
                        if (sec == sectionCount.count) {
                            if ((index.count - 1) == MatchDetails[sec].TotalHighlight[item]["highlight"]) {
                                activePosition = MatchDetails[sec].TotalHighlight[item]["key"];
                                formartValue = MatchDetails[sec].Value;
                            }
                        }
                    }
                }
                if (activePosition != undefined) {
                    if (value.changingThisBreaksApplicationSecurity !== undefined && formartValue.changingThisBreaksApplicationSecurity !== undefined) {
                        value = value.changingThisBreaksApplicationSecurity;
                        formartValue = formartValue.changingThisBreaksApplicationSecurity;
                    }
                    if (value == formartValue) {
                        const searchActiveResult = activeHighlight(value, re, activePosition);
                        return this.sanitizer.bypassSecurityTrustHtml(searchActiveResult);
                    }
                    else {
                        const searchHighlightResult = activeHighlight(value, re, null);
                        return this.sanitizer.bypassSecurityTrustHtml(searchHighlightResult);
                    }
                }
                else {
                    const searchResult = activeHighlight(value, re, null);
                    return this.sanitizer.bypassSecurityTrustHtml(searchResult);
                }
            }
        }

        function activeHighlight(val, reVal, active) {
            var position = 0;
            var value = val.changingThisBreaksApplicationSecurity !== undefined ? val.changingThisBreaksApplicationSecurity : val;
            const result = value.replace(reVal, function (param){
                if (position == active) {     
                    position++;
                    return "<mark class='swapa-contract-active'>" + param + "</mark>"
                }
                else {
                    position++;
                    return "<mark class='swapa-contract-highlight'>" + param + "</mark>"
                }
            });
            return result;
        }
    }
}
